module.exports = __webpack_public_path__ + "img/1535810693.4b93108c.jpg";